import type { ReactNode } from 'react';

export const symbol_shift_lock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-250v-180H182q-19.36 0-27.18-17t4.18-32l298-372q8.88-11 22.94-11T503-851l298 372q12 15 4.18 32T778-430H640v180q0 12.75-8.62 21.37Q622.75-220 610-220H350q-12.75 0-21.37-8.63Q320-237.25 320-250Zm60-30h200v-210h133L480-786 247-490h133v210Zm100-253ZM170-80q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h620q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q802.75-80 790-80H170Z"
		/>
	</svg>
);
